<app-loader [isLoading]="isLoading"></app-loader>
<div class="content">
    <app-restaurant-filter-bar [config]="filterBarConfig" [selectedFilter]="selectedFilter" [searchText]="searchText"
        [startDate]="startDate" [endDate]="endDate" (searchChange)="onSearchChange($event)"
        (filterChange)="onFilterChange($event)" (dateRangeChange)="onDateRangeChange($event)"
        (exportClick)="onExportClick()"></app-restaurant-filter-bar>

    <div style="padding-left: 40px; margin-bottom: 16px;">
        <app-export-excel-button text="Exportar Excel" (exportClick)="onExportClick()">
        </app-export-excel-button>
    </div>

    <app-restaurant-summary-cards [cards]="summaryCards" layout="grid"></app-restaurant-summary-cards>
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8" id="restaurant-table">

        <!-- Columna de Usuarios -->
        <ng-container matColumnDef="users">
            <th mat-header-cell *matHeaderCellDef>
                USUARIO
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">
                    @if(qeqDataLoaded){
                    {{element.employee_name | qeqPipe}}
                    }@else{
                    {{element.employee_name || 'Cargando...'}}
                    }
                </span>
            </td>
        </ng-container>

        <!-- Columna de Id Usuario -->
        <ng-container matColumnDef="id-users">
            <th mat-header-cell *matHeaderCellDef>
                ID EMPLEADO
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.employee_external_id}}</span>
            </td>
        </ng-container>

        <!-- Columna de Fecha de registro -->
        <!-- <ng-container matColumnDef="register-date">
        <th mat-header-cell *matHeaderCellDef>
            FECHA REGISTRO
        </th>
        <td mat-cell *matCellDef="let element">
            <span style="font-size: 16px;">{{element.created_when | customPipe}}</span>
        </td>
    </ng-container> -->

        <!-- Columna de Fecha -->
        <ng-container matColumnDef="diet-date">
            <th mat-header-cell *matHeaderCellDef>
                FECHA RESERVA
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.date | date: 'dd/MM/yyyy'}}</span>
            </td>
        </ng-container>

        <!-- Columna de Consumos -->
        <ng-container matColumnDef="consumed">
            <th mat-header-cell *matHeaderCellDef>
                CONSUMOS
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.meal_type != 'BREAKFAST'){
                <span class="utility-button">Comida</span>

                }@else{
                <button mat-flat-button id="button">
                    <span class="utility-button">Desayuno</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de Estado -->
        <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
                ESTADO
            </th>
            <td mat-cell *matCellDef="let element">
                @if(element.status === 'EATEN'){
                <button mat-flat-button id="consumed">
                    <mat-icon matTextPrefix>check_circle</mat-icon>
                    <span style="font-size: 16px;">Consumido</span>
                </button>
                }@else if (element.status === 'PENDING') {
                <button mat-flat-button id="reservation">
                    <mat-icon matTextPrefix svgIcon="pending"></mat-icon>
                    <span style="font-size: 16px;">Reserva</span>
                </button>
                }@else {
                <button mat-flat-button id="non-consumed">
                    <mat-icon matTextPrefix>cancel</mat-icon>
                    <span style="font-size: 16px;">No consumido</span>
                </button>
                }
            </td>
        </ng-container>

        <!-- Columna de invitados -->
        <ng-container matColumnDef="guests">
            <th mat-header-cell *matHeaderCellDef>
                INVITADOS
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="utility-button">
                    <span style="font-size: 16px;">{{element.guests_number}}</span>
                </span>

            </td>
        </ng-container>

        <!-- Columna de Cobro -->
        <ng-container matColumnDef="payed">
            <th mat-header-cell *matHeaderCellDef>
                COBRO
            </th>
            <td mat-cell *matCellDef="let element">
                @if(myroles.can_write){
                <mat-slide-toggle [checked]="element.punch?.charge ?? element.charge"
                    (change)="togglePaymentStatus(element.id, (element.punch?.charge ?? element.charge), element.employee_name)"
                    [matTooltip]="(element.punch?.charge ?? element.charge) ? 'Marcar como no cobrado' : 'Marcar como cobrado'">
                </mat-slide-toggle>
                }@else{
                <mat-slide-toggle [checked]="element.punch?.charge ?? element.charge" [disabled]="true">
                </mat-slide-toggle>
                }
            </td>
        </ng-container>

        <!-- Columna de celiac -->
        <ng-container matColumnDef="celiac">
            <th mat-header-cell *matHeaderCellDef>
                CELÍACO
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="utility-button">

                    <span style="font-size: 16px;">
                        {{ element.is_celiac ? 'Sí' : 'No' }}
                    </span>
                </span>
            </td>
        </ng-container>


        <!-- Columna de Acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>
            </th>
            <td mat-cell *matCellDef="let element">
                @if(myroles.can_write){
                <button mat-icon-button class="acciones" (click)="viewDetails(element.id)"><mat-icon
                        svgIcon="edit"></mat-icon></button>
                }
                @if(myroles.can_delete){
                <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)"><mat-icon
                        svgIcon="delete"></mat-icon></button>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>